export default "__VITE_ASSET__bi9VdKvE__"